import { Component, Input, OnInit } from '@angular/core';
import { IPageViewModel } from '../pages';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent implements OnInit {

  @Input() vm: IPageViewModel;

  constructor() { }

  ngOnInit() {
  }

}
